import { Gamepad2, Newspaper, Star, Trophy, Vote } from 'lucide-react';
import colors from 'tailwindcss/colors';

// Includes actors, categories, post count, etc.
// via https://github.com/bluesky-social/atproto/discussions/3822
export const trendsUrl = 'https://public.api.bsky.app/xrpc/app.bsky.unspecced.getTrends';

// The shorter version with less fields
export const trendingTopicsUrl =
  'https://public.api.bsky.app/xrpc/app.bsky.unspecced.getTrendingTopics';

export const trendCategories = {
  politics: {
    color: colors.red[200],
    colorLight: colors.red[100],
    icon: Vote,
  },
  'pop-culture': {
    color: colors.blue[200],
    colorLight: colors.blue[100],
    icon: Star,
  },
  'video-games': {
    color: colors.green[200],
    colorLight: colors.green[100],
    icon: Gamepad2,
  },
  sports: {
    color: colors.yellow[200],
    colorLight: colors.yellow[100],
    icon: Trophy,
  },
  news: {
    color: colors.purple[200],
    colorLight: colors.purple[100],
    icon: Newspaper,
  },
} as const;

export const summariseWordCount = 100;
export const summariseMaxTokens = 5000;
export const summariseDateRangeDays = 3;
export const summariseLinksDateRangeDays = 7;

export const webSearchSummariseInitialTopicsOlderThan = '4 hours';
export const neverSummariseTopicsOlderThan = '24 hours';

export const topicStatuses = [
  'pending',
  'initial',
  'webSearch',
  'error',
  'noLookup',
  'review',
] as const;

export const envDefaultDatabaseUrl = 'http://127.0.0.1:8080';
export const envDefaultCronSchedule = 'rate(20 minutes)';
// Note: cache-manager ttl is in milliseconds! https://www.npmjs.com/package/cache-manager#ttl
export const envDefaultCacheTtlSeconds = 1500;
export const envDefaultCacheUrl = 'redis://localhost:6379';
export const envDefaultTrendWindowHours = 72;
export const envDefaultBundledDataStaleTimeSeconds = 0;
